import { tenantName } from '../../config/tenant';

export function PoweredByFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="flex items-center justify-between px-6 py-3 border-t border-ems-border text-xs">
      <span className="text-ems-text-muted">
        &copy; {year} {tenantName}
      </span>
      <div className="flex items-center gap-2">
        <span className="text-ems-text-muted font-medium">Powered by</span>
        <img
          src="/djin-logo.png"
          alt="DJIN"
          className="w-6 h-6 rounded-full object-contain"
        />
      </div>
    </footer>
  );
}
